/**
 * Das **Projekt-Icon** (CONTEXT.md „Projekt-Kopf“) als ein String in
 * `Project.icon`: `happy:<rewardId>`, `emoji:<zeichen>` oder `lucide:<name>`.
 *
 * Ein String statt dreier Spalten, weil es immer genau eines ist — und weil
 * der Sync so eine einzige nullable Spalte kennt.
 */
export type ProjectIconKind = 'happy' | 'emoji' | 'lucide'

export interface ProjectIconValue {
  kind: ProjectIconKind
  value: string
}

const KINDS: readonly ProjectIconKind[] = ['happy', 'emoji', 'lucide']

export function parseProjectIcon(raw: string | null | undefined): ProjectIconValue | null {
  if (!raw) return null
  const colon = raw.indexOf(':')
  if (colon <= 0) return null
  const kind = raw.slice(0, colon) as ProjectIconKind
  const value = raw.slice(colon + 1)
  if (!KINDS.includes(kind) || !value) return null
  return { kind, value }
}

export function formatProjectIcon(icon: ProjectIconValue): string {
  return `${icon.kind}:${icon.value}`
}
